'use strict';

angular.module('gov.filters', []);